import React from "react";
import { Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { Form, Formik, ErrorMessage } from "formik";
import { CreateOrganizationGroupSchema } from "../../../../../../helpers/schemas";
import { updateGroup as updateGroupApi } from "../../../../../../api/admin/groups";
import { Prompt } from "react-router";
import { Messages } from "../../../../../layout/Messages/Messages";
import { GroupFields } from "./GroupFields";
import {
  NOTIFICATION_ADMIN_GROUP_ACTIONS,
} from '../../../../../../config/notifications';
import { scrollToErrors } from '../../../../../../helpers/general';

function GroupEditForm(props) {
  const { group, toggleEditMode, updateGroup } = props;

  const submitForm = (values) => {
    const payload = {
      data: {
        id: group.id,
        name: values.groupName,
      },
      notificationId: NOTIFICATION_ADMIN_GROUP_ACTIONS
    };

    updateGroupApi( payload ).then( (response) => {
      if (response && response.data && response.data.id) {
        toggleEditMode( "group", false );
        updateGroup( response.data );
      }
    } );
  };

  return (
    <div className="admin-group-detail-section admin-group-detail-section--edit">
        <Formik
          key="edit_group"
          initialValues={{
            groupName: group.name || "",
          }}
          validationSchema={CreateOrganizationGroupSchema}
          validateOnChange={false}
          onSubmit={submitForm}
        >
          {(formikProps) => {
            scrollToErrors(formikProps)
            return (
              <Form>
                <div className="mx-2">
                  <Messages color="danger" formikProps={formikProps}>
                    <ErrorMessage
                      name="groupName"
                      component="div"
                      data-testid="errors-groupName"
                      className="field-error"
                    />
                  </Messages>
                </div>

                <Prompt
                  when={formikProps.initialValues !== formikProps.values}
                  message={(location) =>
                    `You have unsaved changes, are you sure you want to leave the form?`
                  }
                />

                <GroupFields formikProps={formikProps} group={group}/>

                <div className="text-right py-3">
                  <Button name="save" type="submit" color="primary" data-testid="save-group-details">
                    <FormattedMessage id="button.save"/>
                  </Button>
                  <Button
                    color="secondary"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleEditMode( "group", false );
                    }}
                  >
                    <FormattedMessage id="button.cancel"/>
                  </Button>
                </div>
              </Form>
            );
          }}
        </Formik>
    </div>
  );
}

export { GroupEditForm };
